import DrugIdMissing from "../../images/icons/DrugIdMissing";
import DrugNRx from "../../images/icons/DrugNRx";
import PatientNmatch from "../../images/icons/PatientNmatch";
import RxNmatch from "../../images/icons/RxNmatch";
import InfoIcon from "../../images/icons/InfoIcon.svg";
import { HtmlTooltip } from "../../Theme";
import { IconButton } from "@mui/material";

export default function AlertDescription({ row }: any) {
  const renderMap: Record<string, JSX.Element[]> = {
    "Patient Not Matched": [<PatientNmatch />],
    "Drug Not Matched With Original NewRx": [<DrugNRx />],
    "Original Rx Not Matched.": [<RxNmatch />],
    "Drug Id Missing": [<DrugIdMissing />],
    "Patient Not Matched. Original Rx Not Matched.": [
      <PatientNmatch />,
      <RxNmatch />,
    ],
    "Original Rx Not Matched.Patient Mismatch.": [
      <RxNmatch />,
      <PatientNmatch />,
    ],
    "Patient Not Matched. Drug Not Matched With Original NewRx": [
      <PatientNmatch />,
      <DrugNRx />,
    ],
    "Drug Not Matched With Original NewRx. Original Rx Not Matched.": [
      <DrugNRx />,
      <RxNmatch />,
    ],
    "Original Rx Not Matched.Drug Not Matched With Original NewRx": [
      <RxNmatch />,
      <DrugNRx />,
    ],
    "Patient Not Matched. Drug Id Missing": [
      <PatientNmatch />,
      <DrugIdMissing />,
    ],
    "Drug Id Missing Original Rx Not Matched.": [
      <DrugIdMissing />,
      <RxNmatch />,
    ],
    "Patient Not Matched. Drug Not Matched With Original NewRx. Original Rx Not Matched.":
      [<PatientNmatch />, <DrugNRx />, <RxNmatch />],
    "Patient Not Matched. Drug Id Missing. Original Rx Not Matched.": [
      <PatientNmatch />,
      <DrugIdMissing />,
      <RxNmatch />,
    ],
  };

  const icons = renderMap[row?.alertDescription] || [
    <img src={InfoIcon} alt="Tooltip" loading="lazy" />,
  ];

  const marginLeft = icons.length > 1 ? (icons.length === 2 ? 12 : 24) : 0;

  return (
    <HtmlTooltip placement="right" arrow title={row?.alertDescription}>
      <IconButton style={{ marginLeft }}>{icons}</IconButton>
    </HtmlTooltip>
  );
}
